import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  padding: 2rem 0;
  margin-bottom: 2rem;
`;

const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  color: white;
`;

const Title = styled.h1`
  color: white;
  margin: 0;
  font-size: 2.5rem;
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.8);
  margin: 0.5rem 0 0;
  font-size: 1.1rem;
`;

const PageHeader = ({ title, subtitle }) => {
  return (
    <HeaderContainer>
      <HeaderContent>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </HeaderContent>
    </HeaderContainer>
  );
};

export default PageHeader;
